<template>
    <div style="margin-bottom: calc(48px + 1.5rem)" v-cloak>
        <b-navbar v-if="customer.phone || customer.email" class="p-0">
            <b-navbar-nav style="flex-shrink: 1; max-height: 1.5rem;" v-if="banner !== ''">
                <marquee-text :repeat="bannerRepeat" :duration="5"><span class="mx-1">{{ banner + ' | '}}</span></marquee-text>
            </b-navbar-nav>
            <b-navbar-nav class="ml-auto" style="flex-shrink: 0">
                <b-nav-item v-if="customer.email" class="py-0" :href="'mailto:' + customer.email" target="_blank">
                    <font-awesome-icon icon="envelope"></font-awesome-icon>
                    {{customer.email}}
                </b-nav-item>
                <b-nav-item v-if="customer.phone" class="ml-4 mr-2 py-0" :href="'tel:' + customer.phone">
                    <font-awesome-icon icon="phone"></font-awesome-icon>
                    {{customer.phone}}
                </b-nav-item>
            </b-navbar-nav>
        </b-navbar>
        <b-navbar toggleable="md" variant="primary" type="dark">
            <b-navbar-brand :to="{ name: 'Publication' }" class="p-0">
                <b-img v-if="logo !== ''" :src="logo" style="max-height: 56px;" alt="Logo"></b-img>
                <template v-else>{{membership.name}}</template>
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item :to="{ name: 'Publication' }" :active="setActivePublicationsMenu">Publicaciones</b-nav-item>
                    <b-nav-item :to="{ name: 'Customer' }" :active="setActiveCustomerMenu">Clientes</b-nav-item>
                    <b-nav-item :to="{ name: 'Settings' }" :active="setActiveSettingMenu">Configuración</b-nav-item>
                </b-navbar-nav>

                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
<!--                    <b-button variant="outline-light">-->
<!--                        <font-awesome-icon icon="bell"></font-awesome-icon>-->
<!--                    </b-button>-->

                    <b-nav-item :to="{ name: 'Profile' }" :active="true">
                        <font-awesome-icon icon="user-circle"></font-awesome-icon> {{user.name}}
                        <span class="mr-2 d-none d-md-inline"></span>
                    </b-nav-item>

                    <b-nav-item :href="BACK_OFFICE_DOCS" target="_blank" :active="true" v-b-tooltip.hover.bottom title="Ayuda">
                        <span class="ml-2 d-none d-md-inline"></span>
                        <font-awesome-icon icon="question-circle"></font-awesome-icon> <span class="d-inline d-md-none">Ayuda</span>
                    </b-nav-item>

                    <b-nav-item @click="logOut" :active="true" v-b-tooltip.hover.bottom title="Cerrar sesión">
                        <span class="ml-2 d-none d-md-inline"></span>
                        <font-awesome-icon icon="sign-out-alt"></font-awesome-icon> <span class="d-inline d-md-none">Cerrar sesión</span>
                    </b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

        <b-breadcrumb v-if="$route.name !== 'Publication' && $route.name !== 'Profile'" :items="breadcrumbItems"></b-breadcrumb>
        <router-view :settings="settings" :application="application" :membership="membership" :customer="customer" :dateFormat="dateFormat"
                     :dateRangeFormat="dateRangeFormat" @update-breadcrumb-items="updateBreadcrumbItems"
                     @user-data-change="updateUserData" :modules="modules"></router-view>

        <b-navbar fixed="bottom" variant="primary">
            <b-progress class="my-1 w-25" :max="membership.storageLimit" height="1.5rem" style="min-width: 120px">
                <b-progress-bar :value="membership.storageUsage" :variant="progressbarVariant">
                </b-progress-bar>
                <span class="justify-content-center d-none d-md-flex position-absolute w-25 text-dark"
                      style="margin-top: .75rem; min-width: 120px">{{ storageUsedLabel() }}</span>
                <span class="justify-content-center d-sm-flex d-md-none position-absolute w-25 text-dark"
                      style="margin-top: .75rem; min-width: 120px">{{ storageUsedLabel(true, true) }}</span>
            </b-progress>
            <div class="my-1 ml-5 w-75 text-left text-light" v-if="showPortalUsersInfo">
                <font-awesome-icon icon="users"></font-awesome-icon>
                {{ membership.activePortalUserQty }} / {{ membership.portalUserLimit }} usuarios
            </div>
        </b-navbar>
    </div>
</template>

<script>
import { logOutUrl, settingUrl, clientTokenUrl, bannerUrl } from '@routes';
import * as constants from '@constants';
import MarqueeText from 'vue-marquee-text-component';

export default {
    data() {
        return {
            banner: '',
            actionsAvailable: true,
            logo: '',
            customer: {
                id: 0,
                hash: '',
                name: '',
                phone: '(442) 241 8154',
                email: 'soporte@tritonix.mx'
            },
            user: {
                id: 0,
                name: '',
                email: '',
                roles: ''
            },
            application: '',
            settings: {
                theme: 'dark',
                customFields: [
                    { id: 0, name: '', enabled: false, field: 'F1', type: 'TEXT', required: false },
                    { id: 0, name: '', enabled: false, field: 'F2', type: 'TEXT', required: false },
                    { id: 0, name: '', enabled: false, field: 'F3', type: 'TEXT', required: false },
                    { id: 0, name: '', enabled: false, field: 'F4', type: 'TEXT', required: false },
                    { id: 0, name: '', enabled: false, field: 'F5', type: 'TEXT', required: false }
                ],
                defaults: {
                    lockDownload: false,
                    attachFiles: false
                },
                dateFormat: {
                    first: 'yyyy',
                    second: 'MM',
                    third: 'dd',
                    separator: '-'
                }
            },
            membership: {
                name: '',
                expirationDate: '',
                storageLimit: 0,
                storageUsage: 0,
                level: '',
                userLimit: 0,
                portalUserLimit: 0,
                userCurrentQty: 0,
                portalUserCurrentQty: 0,
                activePortalUserQty: 0
            },
            breadcrumbItems: [],
            modules: []
        }
    },
    components: {
        MarqueeText
    },
    created() {
        this.application = localStorage.getItem('application');

        // if (this.settings.theme === 'dark') {
        //     import('@/css/theme_darkly.css');
        // } else {
        //     import('@/css/theme.css');
        // }

        this.loadData();
        this.loadBanner();
    },
    mounted() {
        let $this = this;

        function requestPermission() {
            // console.log('Requesting permission...');
            Notification.requestPermission().then(permission => {
                if (permission === 'granted') {
                    // console.log('Notification permission granted.');
                    resetUI();
                } else {
                    // console.log('Unable to get permission to notify.');
                }
            });
        }

        messaging.onTokenRefresh(() => {
            messaging.getToken().then(refreshedToken => {
                // console.log('Token refreshed.');

                localStorage.setItem('clientToken', refreshedToken);
                $this.axios.post(clientTokenUrl(), { token: refreshedToken });
                resetUI();
            }).catch(err => {
                // console.log('Unable to retrieve refreshed token.', err);
            });
        });

        function resetUI() {
            messaging.getToken().then(currentToken => {
                if (currentToken) {
                    localStorage.setItem('clientToken', currentToken);
                    $this.axios.post(clientTokenUrl(), { token: currentToken });
                } else {
                    // console.log('No Instance ID token available. Request permission to generate one.');
                }
            }).catch(err => {
                // console.log('An error occurred while retrieving token.', err);
            });
        }

        requestPermission();

        messaging.onMessage(payload => {
            this.$root.$bvToast.toast(payload.notification.body, {
                title: payload.notification.title,
                variant: 'info'
            });
        });
    },
    methods: {
        loadData() {
            return new Promise(resolve => {
                this.axios.get(settingUrl()).then(response => {
                    if (response.data.code === constants.CODE_OK) {
                        let settings = response.data.settings;
                        let membership = response.data.membership;
                        let user = response.data.user;

                        this.settings.id = settings.id ?? 0;
                        this.settings.defaults.lockDownload = settings.lockDownload ?? false;
                        this.settings.defaults.attachFiles = settings.attachFiles ?? false;

                        this.settings.dateFormat.first = settings.dateFormat?.first ?? 'yyyy';
                        this.settings.dateFormat.second = settings.dateFormat?.second ?? 'MM';
                        this.settings.dateFormat.third = settings.dateFormat?.third ?? 'dd';
                        this.settings.dateFormat.separator = settings.dateFormat?.separator ?? '-';

                        this.membership.name = this.capitalize(membership.name);
                        this.membership.level = membership.level;
                        this.membership.expirationDate = membership.expirationDate;
                        this.membership.storageLimit = membership.storageLimit;
                        this.membership.storageUsage = membership.storageUsage;
                        this.membership.userLimit = membership.userLimit;
                        this.membership.portalUserLimit = membership.portalUserLimit;
                        this.membership.userCurrentQty = membership.userCurrentQty;
                        this.membership.portalUserCurrentQty = membership.portalUserCurrentQty;
                        this.membership.activePortalUserQty = membership.activePortalUserQty;

                        this.modules = response.data.modules;

                        this.logo = membership.logo;

                        this.user.id = user.id;
                        this.user.name = user.name;

                        for (let field of settings.customFields) {
                            let customField = this.settings.customFields.find(customField => customField.field === field.field);

                            if (customField) {
                                customField.id = field.id;
                                customField.name = field.name;
                                customField.enabled = field.enabled;
                                customField.field = field.field;
                                customField.type = field.type;
                                customField.required = field.required;
                            }
                        }
                    }
                }).catch(() => {

                }).finally(resolve);
            });
        },
        loadBanner() {
            this.axios.get(bannerUrl()).then(response => {
                this.banner = response.data.message;
                this.actionsAvailable = response.data.actionsAvailable;

                let date = new Date();

                localStorage.setItem('bannerDate', `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`);
            });
        },
        updateUserData(user) {
            this.user.id = user.id;
            this.user.name = user.name;
        },
        storageUsedLabel(forceGB = false, hidePercentage = false) {
            const ratio = 1024, digits = 2;
            let storageUsed = this.membership.storageUsage;
            let storageLimit = this.membership.storageLimit;
            let unit = 0;
            let units = ['B', 'KB', 'MB', 'GB'];
            let percentage = '';

            if (forceGB) {
                for (let i = 0; i < 3; i++) {
                    storageLimit /= ratio;
                    unit++;
                }
            } else {
                while (storageLimit > 1024) {
                    storageLimit /= ratio;
                    unit++;
                }
            }

            for (let i = 0; i < unit; i++) {
                storageUsed /= ratio;
            }

            if (!hidePercentage) {
                percentage = `(${((storageUsed / storageLimit) * 100).toFixed(digits)}%)`;
            }

            return `${storageUsed.toFixed(digits)} / ${storageLimit.toFixed(digits)} ${units[unit]} ${percentage}`;
        },
        logOut() {
            this.axios.delete(logOutUrl(), {
                data: { clientToken: localStorage.getItem('clientToken') }
            }).finally(() => {
                localStorage.removeItem('userInfo');
                localStorage.removeItem('userSettings');
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                localStorage.removeItem('clientId');
                localStorage.removeItem('clientSecret');
                localStorage.removeItem('application');
                localStorage.removeItem('clientToken');
                localStorage.removeItem('bannerDate');

                this.customer = {
                    id: 0,
                    hash: '',
                    name: '',
                    phone: '',
                    email: ''
                };

                this.user = {
                    id: 0,
                    name: '',
                    email: '',
                    roles: ''
                };

                this.$router.replace({ name: 'BackOfficeLogin', params: { memberName: this.$route.params.memberName }});
            });
        },
        updateBreadcrumbItems(items) {
            this.breadcrumbItems = items;
        },
        capitalize(value) {
            if (!value) {
                return '';
            }

            value.toString();

            return value.charAt(0).toUpperCase() + value.slice(1);
        }
    },
    computed: {
        bannerRepeat() {
            const fullHDWidth = 1920; // px
            const remRatio = Math.round(24 * (2/3)); // Line heigth = 24px = 1.5 rem. 1 rem = 16px

            return this.banner.length === 0 ? 2 : Math.ceil(fullHDWidth / (remRatio * this.banner.length));
        },
        progressbarVariant() {
            const usage = this.membership.storageUsage, limit = this.membership.storageLimit;
            const OK_LIMIT = 0.5;
            const WARN_LIMIT = 0.9;

            return (usage / limit < OK_LIMIT) ? 'success' : (usage / limit < WARN_LIMIT) ? 'warning' : 'danger';
        },
        setActivePublicationsMenu() {
            return (this.$route.name === 'Publication' || this.$route.name === 'PublicationNew' ||
                this.$route.name === 'PublicationEdit' || this.$route.name === 'PublicationEdit');
        },
        setActiveSettingMenu() {
            return (this.$route.name === 'Settings' || this.$route.name === 'UserNew' ||
                this.$route.name === 'UserEdit' || this.$route.name === 'UserShow');
        },
        setActiveCustomerMenu() {
            return (this.$route.name === 'Customer' || this.$route.name === 'CustomerNew' || this.$route.name === 'CustomerEdit' ||
                this.$route.name === 'CustomerShow' || this.$route.name === 'PortalUserNew' || this.$route.name === 'PortalUserEdit' ||
                this.$route.name === 'PortalUserShow' || this.$route.name === 'GroupNew' || this.$route.name === 'GroupEdit');
        },
        showPortalUsersInfo() {
            return ['Customer', 'CustomerShow', 'PortalUserNew', 'PortalUserEdit'].includes(this.$route.name);
        },
        dateFormat() {
            let format = this.settings.dateFormat;
            let separator = format.separator;

            return `${format.first}${separator}${format.second}${separator}${format.third}`;
        },
        dateRangeFormat() {
            let format = this.settings.dateFormat;
            let separator = format.separator;

            let map = new Map([
                ['d', 'd'],
                ['dd', 'dd'],
                ['M', 'm'],
                ['MM', 'mm'],
                ['MMM', 'mmm'],
                ['MMMM', 'mmmm'],
                ['yy', 'yy'],
                ['yyyy', 'yyyy']
            ]);

            return `${map.get(format.first)}${separator}${map.get(format.second)}${separator}${map.get(format.third)}`;
        },
        BACK_OFFICE_DOCS() {
            return constants.BACK_OFFICE_DOCS;
        }
    }
}
</script>

<style>
.marquee-text-content {
    width: auto !important;
}
</style>